import type { DimensionGroup } from '../../schemas/misc/dimension_group.ts'
import type { CoreModel } from '../../schemas/model/model.ts'
import type { CoreView, CoreViewWithMetric } from '../../schemas/View.ts'
import type { ViewConfigAdditionalConfig } from '../../schemas/view_config/index.ts'
import type { ModelSearcher } from './compileViewConfig/ModelSearcher.ts'
import type { ViewSearcher } from './compileViewConfig/ViewSearcher.ts'

export class CompileLog {
  private readonly errors: string[]
  private readonly warns: string[]
  private readonly logs: string[]

  public constructor() {
    this.errors = []
    this.warns = []
    this.logs = []
  }

  public warn(x: string) {
    this.warns.push(x)
  }

  public log(x: string) {
    this.logs.push(x)
  }

  public showWarns() {
    return this.warns
  }

  public error(x: string) {
    this.errors.push(x)
  }

  public showErrors() {
    return this.errors
  }
}

export interface OrganizationSetting {
  userGroupCategoryNames: string[]
  dimensionGroups: DimensionGroup[]
  accountClosingMonth: number
}

export interface CompileResources {
  view: Pick<CoreView, 'id' | 'name'> // 本来はconfigだけで完結させ、viewの情報そのものは不要な想定だったが、kpi周りで必要になった
  models: CoreModel[]
  // compileKpiPivotViewConfig が子 KPI を引くときの母集団。
  // kpi variant の formula は WithMetric 必須なので、producer (attachMetricToView) で
  // attach 済みの view 配列を要求する。
  views: CoreViewWithMetric[]
  organizationSetting: OrganizationSetting
}

export interface CompileContext {
  modelSearcher: ModelSearcher
  viewSearcher: ViewSearcher
  additionalConfig: ViewConfigAdditionalConfig | undefined
  logs: CompileLog
  resources: CompileResources
}
